/**
 * Orchestra AI Platform - Workspace Wrapper
 * 
 * Wrapper component for the Developer Workspace that works with tab-based navigation
 */

import { ProjectManager } from '../Workspace/ProjectManager';
import { TemplateLibrary } from '../Workspace/TemplateLibrary';
import { useState } from 'react';
import PropTypes from 'prop-types';
import '../Workspace/Workspace.css';

/**
 * Orchestra Workspace Component
 * @param {Object} props
 * @param {Object} props.currentUser - Current user object
 * @param {Function} props.onBack - Back navigation handler
 * @param {Function} props.onTabChange - Tab change handler
 */
export function OrchestraWorkspace({ currentUser, onBack, onTabChange }) {
  const [activeTab, setActiveTab] = useState('projects'); // projects, templates

  return (
    <div style={{ padding: '20px', height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h1 style={{ fontSize: '24px', fontWeight: 'bold', color: '#1f2937' }}>
          🎼 Orchestra AI Platform - Developer Workspace
        </h1>
        <button
          onClick={onBack}
          style={{
            padding: '8px 16px',
            backgroundColor: '#6b7280',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer'
          }}
        >
          ← 返回
        </button>
      </div>

      <div className="workspace-tabs">
        <button
          onClick={() => setActiveTab('projects')}
          className={`workspace-tab ${activeTab === 'projects' ? 'active' : ''}`}
        >
          📁 專案管理
        </button>
        <button
          onClick={() => setActiveTab('templates')}
          className={`workspace-tab ${activeTab === 'templates' ? 'active' : ''}`}
        >
          📋 範本庫
        </button>
      </div>

      <div style={{ flex: 1, overflow: 'auto' }}>
        {activeTab === 'projects' && (
          <ProjectManager
            currentUser={currentUser}
            onProjectSelect={(projectId) => {
              onTabChange('workflow-builder', { projectId });
            }}
          />
        )}
        {activeTab === 'templates' && (
          <TemplateLibrary
            currentUser={currentUser}
            onTemplateSelect={(projectId) => {
              // Navigate to workflow builder with the new project
              onTabChange('workflow-builder', { projectId });
            }}
          />
        )}
      </div>
    </div>
  );
}

OrchestraWorkspace.propTypes = {
  currentUser: PropTypes.object,
  onBack: PropTypes.func.isRequired,
  onTabChange: PropTypes.func.isRequired,
};

